var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFocus3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 55,
    viewBox: "0 0 44 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 27.4999L19.5 32.4999L29.5 22.4999M42 29.9999C42 42.4999 33.25 48.7499 22.85 52.3749C22.3054 52.5595 21.7138 52.5506 21.175 52.3499C10.75 48.7499 2 42.4999 2 29.9999V12.4999C2 11.8369 2.26339 11.201 2.73223 10.7321C3.20107 10.2633 3.83696 9.9999 4.5 9.9999C9.5 9.9999 15.75 6.9999 20.1 3.1999C20.6296 2.7474 21.3034 2.49878 22 2.49878C22.6966 2.49878 23.3704 2.7474 23.9 3.1999C28.275 7.0249 34.5 9.9999 39.5 9.9999C40.163 9.9999 40.7989 10.2633 41.2678 10.7321C41.7366 11.201 42 11.8369 42 12.4999V29.9999Z",
    stroke: "#4771FE",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocus3);
export default __webpack_public_path__ + "static/media/focus-3.349abd9713d0f4190950bbd71fb7ba7a.svg";
export { ForwardRef as ReactComponent };